import React, {useContext, useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";

import {
    Button, Checkbox,
    Dialog, DialogActions,
    DialogContent, DialogTitle, FormControlLabel, FormGroup,
    Menu,
    MenuItem,
    Badge, Paper, Switch, Card
} from "@mui/material";
import Grid from '@mui/material/Grid';
import ListItemText from "@mui/material/ListItemText";
import dayjs from "dayjs";
import MealCard from "../Meals/MealCard";
import Typography from "@mui/material/Typography";
import './meals.css';
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import InfoMeals from "../../Dialogs/InfoMeals";
import Meal from "../../../MasterEventObjects/Meal";
import ListItemIcon from "@mui/material/ListItemIcon";
import {PAContext} from "../../../Services/PAContext";
import {Stack} from "@mui/system";


function MealsList(props) {

    const navigate = useNavigate();

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { sendSocketMessage } = useContext(PAContext);

    const eventDates = PA_GlobalObject.Planning.time_table?.dates || [];
    const [eventMeals, setEventMeals] = useState([]);
    const [filteredMeals, setFilteredMeals] = useState([]);

    const [viewType, setViewType] = useState(
        usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.dates?.length > 0 ?
            'dates'
            : usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.days?.length > 0 ?
                'days' : 'dates');
    const [eventHasDates, setEventHasDates] = useState(usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.dates?.length > 0);
    const [eventHasDays, setEventHasDays] = useState(usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.days?.length > 0);
    const [selectedDate, setSelectedDate] = useState("all");
    const [selectedDay, setSelectedDay] = useState("all");

    const [newlyCreatedMealId, setNewlyCreatedMealId] = useState(null);

    const handleToggleViewType = () => {
        const planning = usePA_GlobalStore.getState().PA_GlobalObject.Planning;
        const eventDays = planning.time_table?.days || [];
        const eventDates = planning.time_table?.dates || [];

        if (viewType === 'dates') {
            if (selectedDate === 'all') {
                setSelectedDay('all');
            } else {
                const correspondingDay = eventDates.find(dateEntry => dateEntry.date === selectedDate);
                if (correspondingDay) {
                    const dayIndex = eventDates.indexOf(correspondingDay);
                    const correspondingDayKey = Object.keys(eventDays[dayIndex] || {})[0] || 'all';
                    setSelectedDay(correspondingDayKey);
                } else {
                    setSelectedDay('all');
                }
            }
            setViewType('days');
        } else if (viewType === 'days') {
            if (selectedDay === 'all') {
                setSelectedDate('all');
            } else {
                const correspondingDayEntry = eventDays.find(dayEntry => Object.keys(dayEntry)[0] === selectedDay);
                if (correspondingDayEntry) {
                    const dayIndex = eventDays.indexOf(correspondingDayEntry);
                    const correspondingDate = eventDates[dayIndex]?.date || 'all';
                    setSelectedDate(correspondingDate);
                } else {
                    setSelectedDate('all');
                }
            }
            setViewType('dates');
        }
    };


    const [anchorMealsListMenu, setAnchorMealsListMenu] = useState(null);
    const handleMealsListMenuOpenMenu = (event) => {
        setAnchorMealsListMenu(event.currentTarget);
    };

    const handleMealsListMenuClick = (event) => {
        // 1. Extract DOM values immediately before any async execution
        const dataId = event.currentTarget.getAttribute('data-id');

        handleMealsListMenuClose();

        if (dataId === "new-entry") {
            navigate('/Planner/Meals/AddNew');
            return;
        }

        const MEAL_TYPES = ["breakfast", "brunch", "lunch", "snack", "dinner", "dessert"];

        if (!MEAL_TYPES.includes(dataId)) return;

        // Helper to get standard default time range based on meal type
        const getMealTimes = (type) => {
            switch (type.toLowerCase()) {
                case 'breakfast':
                    return { begin_time: '8:00 AM', end_time: '9:00 AM' };
                case 'brunch':
                    return { begin_time: '11:00 AM', end_time: '12:30 PM' };
                case 'lunch':
                    return { begin_time: '12:30 PM', end_time: '1:30 PM' };
                case 'snack':
                    return { begin_time: '3:30 PM', end_time: '4:00 PM' };
                case 'dinner':
                    return { begin_time: '6:30 PM', end_time: '8:00 PM' };
                case 'dessert':
                    return { begin_time: '8:30 PM', end_time: '9:30 PM' };
                default:
                    return { begin_time: '12:00 PM', end_time: '1:00 PM' };
            }
        };

        const mealTimes = getMealTimes(dataId);

        // Read current state cleanly
        const globalState = usePA_GlobalStore.getState().PA_GlobalObject;
        const planning = globalState?.Planning || {};

        // 2. Instantiate and setup new meal object
        const newMeal = new Meal();
        newMeal.name = dataId;
        newMeal.id = newMeal.id || `temp_${Date.now()}`;

        // 3. Handle Timetable based on viewType
        if (viewType === 'dates' && selectedDate !== 'all') {
            newMeal.time_table = {
                ...newMeal.time_table,
                dates: [{ date: selectedDate, ...mealTimes }]
            };
        } else if (viewType === 'days' && selectedDay !== 'all') {
            const currentDayObj = planning.time_table?.days?.find(d => selectedDay in d);
            const dayName = currentDayObj ? currentDayObj[selectedDay] : "";

            newMeal.time_table = {
                ...newMeal.time_table,
                days: [{ [selectedDay]: dayName, ...mealTimes }]
            };
        }

        // 4. Map attendees filtering out excluded roles & status
        const attendees = planning.attendees || [];
        const EXCLUDED_ROLES = new Set(['planner', 'partial']);

        if (attendees.length > 0) {
            newMeal.attendees = attendees
                .filter((att) => !EXCLUDED_ROLES.has(att.role) && att.rsvp !== 'decline')
                .map((att) => ({
                    id: att.id,
                    cost: 0,
                    is_business_expense: false,
                    business_expense_amount_authorized: 0,
                    business_expense_amount_authorized_by: "",
                    business_expense_amount_authorized_timestamp: 0,
                    business_expense_amount: 0,
                    business_expense_paid: 0,
                    business_expense_reference_id: "",
                }));
        }

        // 5. Update local state and trigger WebSocket
        setNewlyCreatedMealId(newMeal.id);

        set_PA_GlobalObject((prev) => ({
            ...prev,
            Planning: {
                ...prev.Planning,
                meals: [...(prev.Planning?.meals || []), newMeal],
            },
        }));

        // 6. Socket emit check
        if (planning.status !== 10) {
            sendSocketMessage({
                action: "E_addEventMeal_v2",
                event_id: planning.id,
                meal: newMeal
            });
        }
    };

    const handleMealsListMenuClose = () => {
        setAnchorMealsListMenu(null);
    };

    useEffect(() => {
        if (newlyCreatedMealId && filteredMeals.length > 0) {
            const targetElement = document.getElementById(`meal-container-${newlyCreatedMealId}`);
            if (targetElement) {
                setTimeout(() => {
                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    targetElement.classList.add('newly-added-pulse');

                    setTimeout(() => {
                        targetElement.classList.remove('newly-added-pulse');
                    }, 2000);

                    setNewlyCreatedMealId(null);
                }, 100);
            }
        }
    }, [filteredMeals, newlyCreatedMealId]);

    useEffect(() => {
        const currentMeals = usePA_GlobalStore.getState().PA_GlobalObject.Planning.meals;
        if (currentMeals !== eventMeals) {
            setEventMeals(currentMeals);
            setEventHasDates(usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.dates?.length > 0);
            setEventHasDays(usePA_GlobalStore.getState().PA_GlobalObject.Planning.time_table?.days?.length > 0);
        }
    }, [PA_GlobalObject.Planning.meals]);

    useEffect(() => {
        console.log("there WERE chances to the event meals!! : ", eventMeals);

        console.log("viewType : ", viewType);
        console.log("selectedDate : ", selectedDate);

        if ((viewType === 'dates' && selectedDate === 'all') || (viewType === 'days' && selectedDay === 'all')){
            handleMealChipAllClick();
        } else if (viewType === 'dates') {
            handleMealChipDateClick(selectedDate);
        } else if (viewType === 'days') {
            handleMealChipDayClick(selectedDay);
        }
    }, [eventMeals]);

    // Safe multi-type sorting helper
    const checkIsCancelled = (meal) => {
        if (meal.status === 7 || meal.status === 8) return true;
        const normalized = String(meal.status || '').toLowerCase();
        return normalized === 'cancelled' || normalized === 'canceled';
    };

    const sortMealsByStatusAndTime = (mealsArray) => {
        // Priority order for meal types when sorting unassigned meals
        const MEAL_TYPE_ORDER = {
            breakfast: 1,
            brunch: 2,
            lunch: 3,
            snack: 4,
            dinner: 5,
            dessert: 6
        };

        return [...mealsArray].sort((a, b) => {
            // 1. Check Cancellation Status (Cancelled meals always sink to the bottom)
            const isCancelledA = checkIsCancelled(a);
            const isCancelledB = checkIsCancelled(b);

            if (isCancelledA && !isCancelledB) return 1;
            if (!isCancelledA && isCancelledB) return -1;

            // 2. Check if Date/Day schedule is assigned
            const hasScheduleA = Boolean(
                (Array.isArray(a?.time_table?.dates) && a.time_table.dates.length > 0) ||
                (Array.isArray(a?.time_table?.days) && a.time_table.days.length > 0)
            );

            const hasScheduleB = Boolean(
                (Array.isArray(b?.time_table?.dates) && b.time_table.dates.length > 0) ||
                (Array.isArray(b?.time_table?.days) && b.time_table.days.length > 0)
            );

            // Put unassigned meals before assigned meals
            if (!hasScheduleA && hasScheduleB) return -1;
            if (hasScheduleA && !hasScheduleB) return 1;

            // 3. If BOTH are unassigned, sort by meal type order
            if (!hasScheduleA && !hasScheduleB) {
                const typeA = MEAL_TYPE_ORDER[a?.name?.toLowerCase()] || 99;
                const typeB = MEAL_TYPE_ORDER[b?.name?.toLowerCase()] || 99;
                return typeA - typeB;
            }

            // 4. If BOTH are assigned, sort chronologically by date/time
            const timeA = a.time_table.dates?.[0]?.begin_time || a.time_table.days?.[0]?.begin_time || '00:00';
            const timeB = b.time_table.dates?.[0]?.begin_time || b.time_table.days?.[0]?.begin_time || '00:00';

            const dateA = a.time_table.dates?.[0]?.date
                || (Array.isArray(a.time_table.days) && a.time_table.days[0]
                    ? dayjs().day(parseInt(Object.keys(a.time_table.days[0])[0].replace('day ', ''), 10)).format('YYYY-MM-DD')
                    : null);

            const dateB = b.time_table.dates?.[0]?.date
                || (Array.isArray(b.time_table.days) && b.time_table.days[0]
                    ? dayjs().day(parseInt(Object.keys(b.time_table.days[0])[0].replace('day ', ''), 10)).format('YYYY-MM-DD')
                    : null);

            const dateTimeA = dayjs(`${dateA} ${timeA}`, ['YYYY-MM-DD h:mm A', 'YYYY-MM-DD HH:mm']);
            const dateTimeB = dayjs(`${dateB} ${timeB}`, ['YYYY-MM-DD h:mm A', 'YYYY-MM-DD HH:mm']);

            if (!dateTimeA.isValid() && !dateTimeB.isValid()) return 0;
            if (!dateTimeA.isValid()) return 1;
            if (!dateTimeB.isValid()) return -1;

            return dateTimeA.diff(dateTimeB);
        });
    };
    function handleMealChipAllClick(){
        setSelectedDate('all');
        setSelectedDay('all');

        let filtered = [...eventMeals];
        filtered = sortMealsByStatusAndTime(filtered);
        setFilteredMeals(filtered);
    }

    function handleMealChipDateClick(_meal_date){
        if (viewType !== "dates"){
            setViewType("dates");
        }
        setSelectedDate(_meal_date);
        setSelectedDay('');

        let filtered = eventMeals.filter(meal => {
            const datesArray = meal.time_table?.dates;
            if (!datesArray || !Array.isArray(datesArray)) return false;
            return datesArray.some(d => d.date === _meal_date);
        });

        filtered = sortMealsByStatusAndTime(filtered);
        setFilteredMeals(filtered);
    }

    function handleMealChipDayClick(_meal_day){
        if (viewType !== "days"){
            setViewType("days");
        }
        setSelectedDay(_meal_day);
        setSelectedDate('');

        let filtered = eventMeals.filter(meal =>
            meal.time_table?.days?.length > 0 && Object.keys(meal.time_table.days[0])[0] === _meal_day
        );

        filtered = filtered.sort((a, b) => {
            const isCancelledA = checkIsCancelled(a);
            const isCancelledB = checkIsCancelled(b);

            if (isCancelledA && !isCancelledB) return 1;
            if (!isCancelledA && isCancelledB) return -1;

            const entryA = a.time_table.days.find(d => _meal_day in d);
            const entryB = b.time_table.days.find(d => _meal_day in d);

            const startA = entryA?.begin_time || '12:00 AM';
            const startB = entryB?.begin_time || '12:00 AM';
            const endA = entryA?.end_time || '11:59 PM';
            const endB = entryB?.end_time || '11:59 PM';

            const momentStartA = dayjs(startA, 'h:mm A');
            const momentStartB = dayjs(startB, 'h:mm A');

            if (!momentStartA.isSame(momentStartB)) {
                return momentStartA.diff(momentStartB);
            }

            const momentEndA = dayjs(endA, 'h:mm A');
            const momentEndB = dayjs(endB, 'h:mm A');
            return momentEndA.diff(momentEndB);
        });

        setFilteredMeals(filtered);
    }

    const [fillMealsModalOpen, setFillMealsModalOpen] = useState(false);
    const [selectedMeals, setSelectedMeals] = useState(["breakfast", "brunch", "lunch", "snack", "dinner", "dessert"]);
    const [mealType, setMealType] = useState("meal-out");
    const handleOpenFillMealsModal = () => {
        setFillMealsModalOpen(true);
    };

    const toggleSelectedMeal = (meal) => {
        setSelectedMeals((prev) =>
            prev.includes(meal)
                ? prev.filter((m) => m !== meal)
                : [...prev, meal]
        );
    };

    const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

    function handleConfirmFillMeals() {
        const existingDates = PA_GlobalObject.Planning.meals.map(m => `${m.date}_${m.name?.toLowerCase()}`);
        const newMeals = [];

        eventDates.forEach(date => {
            selectedMeals.forEach(meal => {
                const key = `${date.date}_${meal}`;
                if (!existingDates.includes(key)) {
                    newMeals.push({
                        title: capitalize(meal),
                        date: date.date,
                        type: mealType === "meal-in" ? "Meal In" : "Meal Out",
                        location: null,
                        isPlaceholder: true,
                    });
                }
            });
        });

        setEventMeals([...PA_GlobalObject.Planning.meals, ...newMeals]);
        setFillMealsModalOpen(false);
    }

    const [mealToDelete, setMealToDelete] = useState(null);
    const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const handleDeleteMeal = (mealId) => {
        const updatedMeals = eventMeals.filter(meal => meal.id !== mealId);
        setEventMeals(updatedMeals);

        set_PA_GlobalObject((prev) => ({
            Planning: {
                ...prev.Planning,
                meals: updatedMeals,
            },
        }));

        if (PA_GlobalObject.Planning.status !== 10){
            const _sendString = {};
            _sendString.action = "E_deleteEventMeal_v2";
            _sendString.event_id = PA_GlobalObject.Planning.id;
            _sendString.meal_id = mealId;

            sendSocketMessage(_sendString);
        }
        closeDeleteDialog();
    };

    const openDeleteDialog = (meal) => {
        setMealToDelete(meal);
        setDeleteDialogOpen(true);
    };
    const closeDeleteDialog = () => {
        setMealToDelete(null);
        setDeleteDialogOpen(false);
    };

    const [isMealsInfoDialogOpen, setMealsInfoDialogOpen] = useState(false);



    return (

        <div className="meals-list-container">

            {/* --- MEAL LIST HEADER --- */}
            <Paper
                elevation={0}
                sx={{
                    p: 1.5,
                    background: 'rgba(255, 255, 255, 0.8)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.6)',
                    boxShadow: '0 4px 24px -6px rgba(0,0,0,0.06)',
                    borderRadius: '12px 12px 0 0',
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{
                            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                            p: 0.9,
                            borderRadius: '10px',
                            display: 'flex',
                            boxShadow: '0 4px 10px rgba(16, 185, 129, 0.3)'
                        }}>
                            <i className="icon-fork-knife2" style={{ color: 'white', fontSize: '18px' }} />
                        </Box>
                        <Box sx={{ minWidth: 0 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b', fontSize: '1rem', letterSpacing: -0.4 }}>
                                    Meals
                                </Typography>
                            </Box>
                            <Typography variant="caption" sx={{ color: '#059669', fontWeight: 700, fontSize: '0.65rem', textTransform: 'uppercase' }}>
                                Dining Schedule
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{
                            display: 'flex',
                            bgcolor: '#f1f5f9',
                            p: 0.5,
                            borderRadius: '12px',
                            border: '1px solid #e2e8f0'
                        }}>
                            <Box
                                onClick={() => viewType !== 'dates' && handleToggleViewType()}
                                sx={{
                                    px: 1.5, py: 0.5, borderRadius: '8px', cursor: 'pointer',
                                    bgcolor: viewType === 'dates' ? '#fff' : 'transparent',
                                    boxShadow: viewType === 'dates' ? '0 2px 6px rgba(0,0,0,0.06)' : 'none',
                                    transition: '0.2s',
                                    display: 'flex', alignItems: 'center'
                                }}
                            >
                                <Typography sx={{ fontSize: '10px', fontWeight: 800, color: viewType === 'dates' ? '#10b981' : '#64748b' }}>
                                    DATES
                                </Typography>
                            </Box>

                            <Box
                                onClick={() => viewType !== 'days' && handleToggleViewType()}
                                sx={{
                                    px: 1.5, py: 0.5, borderRadius: '8px', cursor: 'pointer',
                                    bgcolor: viewType === 'days' ? '#fff' : 'transparent',
                                    boxShadow: viewType === 'days' ? '0 2px 6px rgba(0,0,0,0.06)' : 'none',
                                    transition: '0.2s',
                                    display: 'flex', alignItems: 'center'
                                }}
                            >
                                <Typography sx={{ fontSize: '10px', fontWeight: 800, color: viewType === 'days' ? '#10b981' : '#64748b' }}>
                                    DAYS
                                </Typography>
                            </Box>
                        </Box>

                        <IconButton
                            onClick={handleMealsListMenuOpenMenu}
                            sx={{
                                bgcolor: '#10b981',
                                color: 'white',
                                borderRadius: '10px',
                                width: '36px',
                                height: '36px',
                                boxShadow: '0 4px 12px rgba(16, 185, 129, 0.2)',
                                '&:hover': { bgcolor: '#059669' }
                            }}
                        >
                            <i className="icon-menu2" style={{ fontSize: '16px' }} />
                        </IconButton>

                        <Menu
                            anchorEl={anchorMealsListMenu}
                            open={Boolean(anchorMealsListMenu)}
                            onClose={handleMealsListMenuClose}
                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                            PaperProps={{
                                sx: {
                                    mt: 1.5,
                                    width: 280,
                                    borderRadius: '16px',
                                    boxShadow: '0 10px 40px -10px rgba(0,0,0,0.15)',
                                    border: '1px solid #e2e8f0',
                                    overflow: 'visible',
                                    '&:before': {
                                        content: '""',
                                        display: 'block',
                                        position: 'absolute',
                                        top: 0,
                                        right: 14,
                                        width: 10,
                                        height: 10,
                                        bgcolor: 'background.paper',
                                        transform: 'translateY(-50%) rotate(45deg)',
                                        zIndex: 0,
                                        borderLeft: '1px solid #e2e8f0',
                                        borderTop: '1px solid #e2e8f0',
                                    },
                                }
                            }}
                        >
                            <Box sx={{ px: 2, pt: 1.5, pb: 0.5 }}>
                                <Typography sx={{ fontWeight: 900, color: '#94a3b8', fontSize: '0.65rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                    Add Daily Meal
                                </Typography>
                            </Box>

                            <Box sx={{ px: 1 }}>
                                {[
                                    { label: "Breakfast", icon: "icon-fried-egg", color: '#f59e0b' },
                                    { label: "Brunch", icon: "icon-toast", color: '#fbbf24' },
                                    { label: "Lunch", icon: "icon-burger", color: '#ef4444' },
                                    { label: "Snack", icon: "icon-apple", color: '#10b981' },
                                    { label: "Dinner", icon: "icon-platter", color: '#6366f1' },
                                    { label: "Dessert", icon: "icon-ice-cream", color: '#ec4899' },
                                ].map((meal) => (
                                    <MenuItem
                                        key={meal.label}
                                        data-id={meal.label.toLowerCase()}
                                        onClick={handleMealsListMenuClick}
                                        sx={{
                                            borderRadius: '10px',
                                            my: 0.2,
                                            py: 1,
                                            '&:hover': { bgcolor: '#f0fdf4' }
                                        }}
                                    >
                                        <ListItemIcon sx={{ minWidth: '36px !important' }}>
                                            <i className={meal.icon} style={{ color: meal.color, fontSize: '18px' }} />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={meal.label}
                                            primaryTypographyProps={{ fontSize: '0.85rem', fontWeight: 700, color: '#1e293b' }}
                                        />
                                    </MenuItem>
                                ))}
                            </Box>

                            <Divider sx={{ my: 1, opacity: 0.6 }} />

                            <Box sx={{ px: 2, pt: 0.5, pb: 0.5 }}>
                                <Typography sx={{ fontWeight: 900, color: '#94a3b8', fontSize: '0.65rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                    Logistics
                                </Typography>
                            </Box>

                            <Box sx={{ px: 1 }}>
                                {[
                                    { label: "Meal Out", icon: "icon-table", id: "meal-out", color: '#64748b' },
                                    { label: "Meal In", icon: "icon-home3", id: "meal-in", color: '#64748b' },
                                ].map((option) => (
                                    <MenuItem
                                        key={option.id}
                                        data-id={option.id}
                                        onClick={handleMealsListMenuClick}
                                        sx={{ borderRadius: '10px', my: 0.2, '&:hover': { bgcolor: '#f1f5f9' } }}
                                    >
                                        <ListItemIcon sx={{ minWidth: '36px !important' }}>
                                            <i className={option.icon} style={{ fontSize: '16px', color: option.color }} />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={option.label}
                                            primaryTypographyProps={{ fontSize: '0.85rem', fontWeight: 600, color: '#475569' }}
                                        />
                                    </MenuItem>
                                ))}
                            </Box>

                            <Divider sx={{ my: 1, opacity: 0.6 }} />

                            <Box sx={{ px: 1, pb: 1 }}>
                                <MenuItem
                                    onClick={handleOpenFillMealsModal}
                                    sx={{
                                        borderRadius: '12px',
                                        bgcolor: '#ecfdf5',
                                        '&:hover': { bgcolor: '#d1fae5' },
                                        py: 1.5
                                    }}
                                >
                                    <ListItemIcon sx={{ minWidth: '36px !important' }}>
                                        <i className="icon-calendar-plus" style={{ color: '#059669', fontSize: '20px' }} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Fill All Meals"
                                        secondary="Auto-populate your trip with meal placeholders."
                                        primaryTypographyProps={{ fontSize: '0.85rem', fontWeight: 800, color: '#065f46' }}
                                        secondaryTypographyProps={{ fontSize: '0.65rem', sx: { mt: 0.5, lineHeight: 1.2 } }}
                                    />
                                </MenuItem>
                            </Box>
                        </Menu>
                    </Box>
                </Box>
            </Paper>

            {/* --- MEAL TIMETABLE NAVIGATION --- */}
            <Box
                className="meals-list-timetable-list-container"
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'nowrap',
                    overflow: 'auto',
                    gap: 1.5,
                    py: 2,
                    px: 1,
                }}
            >
                {(eventHasDates || eventHasDays) && (
                    <Box
                        onClick={handleMealChipAllClick}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            cursor: 'pointer',
                            minWidth: '60px',
                            transition: 'all 0.2s ease',
                        }}
                    >
                        <Box sx={{
                            width: 45,
                            height: 50,
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: (viewType === 'dates' ? selectedDate === 'all' : selectedDay === 'all')
                                ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                                : '#fff',
                            border: (viewType === 'dates' ? selectedDate === 'all' : selectedDay === 'all')
                                ? 'none'
                                : '1px solid #e2e8f0',
                            boxShadow: (viewType === 'dates' ? selectedDate === 'all' : selectedDay === 'all') ? '0 4px 12px rgba(16, 185, 129, 0.3)' : 'none',
                            transition: 'all 0.3s ease'
                        }}>
                            <Typography sx={{
                                fontWeight: 900,
                                fontSize: '0.75rem',
                                color: (viewType === 'dates' ? selectedDate === 'all' : selectedDay === 'all') ? '#fff' : '#64748b'
                            }}>
                                ALL
                            </Typography>
                        </Box>
                    </Box>
                )}

                {viewType === 'dates' && eventHasDates ? (
                    PA_GlobalObject.Planning['time_table'].dates.map((eventDateObj) => {
                        const eventDate = eventDateObj.date;
                        const isSelected = selectedDate === eventDate;
                        const dayName = dayjs(eventDate).format('ddd').toUpperCase();
                        const dateNum = dayjs(eventDate).format('D');

                        const mealsForDate = eventMeals.filter(meal =>
                            meal.time_table?.dates?.length > 0 && meal.time_table.dates[0].date === eventDate
                        );
                        const count = mealsForDate.length;

                        return (
                            <Box
                                key={`meal-date-${eventDate}`}
                                onClick={() => handleMealChipDateClick(eventDate)}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    minWidth: '60px',
                                    transition: 'all 0.2s ease',
                                }}
                            >
                                <Badge
                                    badgeContent={count > 0 ? count : null}
                                    sx={{
                                        '& .MuiBadge-badge': {
                                            backgroundColor: '#dcfce7',
                                            color: '#065f46',
                                            fontSize: '10px',
                                            fontWeight: 900,
                                            border: '2px solid #fff',
                                            top: 4,
                                            right: 4
                                        },
                                    }}
                                >
                                    <Box sx={{
                                        width: 45,
                                        height: 50,
                                        borderRadius: '12px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: isSelected
                                            ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                                            : '#fff',
                                        border: isSelected ? 'none' : count === 0 ? '1px dashed #fda4af' : '1px solid #e2e8f0',
                                        boxShadow: isSelected ? '0 4px 12px rgba(16, 185, 129, 0.3)' : 'none',
                                        transition: 'all 0.3s ease'
                                    }}>
                                        <Typography sx={{ fontSize: '10px', fontWeight: 800, color: isSelected ? 'rgba(255,255,255,0.8)' : '#94a3b8', lineHeight: 1 }}>
                                            {dayName}
                                        </Typography>
                                        <Typography sx={{ fontSize: '1.1rem', fontWeight: 900, color: isSelected ? '#fff' : (count === 0 ? '#ef4444' : '#1e293b'), lineHeight: 1.2 }}>
                                            {dateNum}
                                        </Typography>
                                    </Box>
                                </Badge>
                            </Box>
                        );
                    })
                ) : viewType === 'days' && eventHasDays ? (
                    PA_GlobalObject.Planning['time_table'].days.map((dayObj) => {
                        const dayKey = Object.keys(dayObj).find(k => k.toLowerCase().startsWith('day')) || 'all';
                        const dayNumber = dayKey.toLowerCase().replace('day', '').trim();
                        const dayName = dayObj[dayKey];
                        const isSelected = selectedDay === dayKey;

                        const mealsForDay = eventMeals.filter(meal =>
                            meal.time_table?.days?.length > 0 && meal.time_table.days[0][dayKey] === dayName
                        );
                        const count = mealsForDay.length;

                        return (
                            <Box
                                key={`meal-day-${dayNumber}`}
                                onClick={() => handleMealChipDayClick(dayKey)}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    minWidth: '65px',
                                    transition: 'all 0.2s ease',
                                }}
                            >
                                <Badge
                                    badgeContent={count > 0 ? count : null}
                                    sx={{
                                        '& .MuiBadge-badge': {
                                            backgroundColor: '#dcfce7',
                                            color: '#065f46',
                                            fontSize: '10px',
                                            fontWeight: 900,
                                            border: '2px solid #fff',
                                            top: 4,
                                            right: 4
                                        }
                                    }}
                                >
                                    <Box sx={{
                                        width: 50,
                                        height: 50,
                                        borderRadius: '12px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        background: isSelected
                                            ? 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
                                            : '#fff',
                                        border: isSelected ? 'none' : count === 0 ? '1px dashed #fda4af' : '1px solid #e2e8f0',
                                        transition: 'all 0.3s ease'
                                    }}>
                                        <Typography sx={{ fontSize: '10px', fontWeight: 800, color: isSelected ? 'rgba(255,255,255,0.8)' : '#94a3b8' }}>
                                            DAY
                                        </Typography>
                                        <Typography sx={{ fontSize: '0.85rem', fontWeight: 900, color: isSelected ? '#fff' : (count === 0 ? '#ef4444' : '#1e293b') }}>
                                            {dayNumber}
                                        </Typography>
                                    </Box>
                                </Badge>
                            </Box>
                        );
                    })
                ) : null}
            </Box>

            {/* --- MEAL CARDS GRID --- */}
            <div className={props.showingPageHeader ? "meals-list-items-container with-header" : "meals-list-items-container"}>
                {
                    filteredMeals.length > 0 ? (
                        filteredMeals.map((mealDetails, index) => {
                            const isCancelled = checkIsCancelled(mealDetails);

                            if (isCancelled) {
                                return (
                                    <Grid
                                        item
                                        key={mealDetails.id}
                                        sx={{ display: 'block', marginBottom: '10px' }}
                                    >
                                        <Card
                                            sx={{
                                                borderRadius: '12px',
                                                background: 'rgba(239, 68, 68, 0.04)',
                                                backdropFilter: 'blur(8px)',
                                                border: '1px dashed rgba(239, 68, 68, 0.3)',
                                                p: '10px 16px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                transition: 'all 0.2s',
                                                '&:hover': { background: 'rgba(239, 68, 68, 0.07)' }
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                <i className="icon-cancel-circle" style={{ color: '#ef4444', fontSize: '16px' }} />
                                                <Box>
                                                    <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#b91c1c', textTransform: 'uppercase', fontSize: '11px', letterSpacing: '0.02em' }}>
                                                        {mealDetails.name || 'Meal'} — {mealDetails.status === 8 ? 'Cancelled by Venue' : 'Cancelled by Us'}
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 500 }}>
                                                        {mealDetails.location?.name || 'No Restaurant Assigned'}
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <MealCard
                                                    meal={mealDetails}
                                                    onDeleteMeal={() => openDeleteDialog(mealDetails)}
                                                    _global_map_ref={props._global_map_ref}
                                                />
                                            </Box>
                                        </Card>
                                    </Grid>
                                );
                            }

                            return (
                                <Grid
                                    item
                                    key={mealDetails.id}
                                    sx={{ display: 'block', marginBottom: '10px' }}
                                >
                                    <MealCard
                                        meal={mealDetails}
                                        onDeleteMeal={() => openDeleteDialog(mealDetails)}
                                        _global_map_ref={props._global_map_ref}
                                    />
                                </Grid>
                            );
                        })
                    ) : (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                py: 3,
                                px: 3,
                                mx: 'auto',
                                maxWidth: '450px',
                                borderRadius: '24px',
                                background: 'rgba(255, 255, 255, 0.6)',
                                backdropFilter: 'blur(10px)',
                                border: '2px dashed #d1fae5',
                                textAlign: 'center',
                            }}
                        >
                            <Box sx={{
                                width: 80,
                                height: 80,
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mb: 3,
                                boxShadow: '0 10px 20px -5px rgba(16, 185, 129, 0.15)',
                            }}>
                                <i className="icon-table" style={{ fontSize: '36px', color: '#10b981' }} />
                            </Box>

                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b', mb: 1 }}>
                                The kitchen is quiet...
                            </Typography>

                            <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500, mb: 4, lineHeight: 1.6 }}>
                                No meals planned for this {selectedDate ? 'date' : 'day'}. Whether you're
                                dining out, ordering in, or cooking a masterpiece, let's get it on the schedule!
                            </Typography>

                            <Box sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gap: 2,
                                width: '100%',
                                mb: 4,
                                textAlign: 'left'
                            }}>
                                <Box sx={{ p: 1.5, bgcolor: 'rgba(255,255,255,0.4)', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                                    <Typography variant="caption" sx={{ fontWeight: 900, color: '#10b981', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <i className="icon-map-pin" /> EXPLORE
                                    </Typography>
                                    <Typography variant="caption" sx={{ display: 'block', color: '#64748b', mt: 0.5, fontSize: '0.65rem' }}>
                                        Search the map for local top-rated eateries.
                                    </Typography>
                                </Box>
                                <Box sx={{ p: 1.5, bgcolor: 'rgba(255,255,255,0.4)', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                                    <Typography variant="caption" sx={{ fontWeight: 900, color: '#10b981', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <i className="icon-home3" /> COOKING
                                    </Typography>
                                    <Typography variant="caption" sx={{ display: 'block', color: '#64748b', mt: 0.5, fontSize: '0.65rem' }}>
                                        Planning a home meal? Add a "Meal In" placeholder.
                                    </Typography>
                                </Box>
                            </Box>

                            <Button
                                variant="contained"
                                onClick={handleMealsListMenuOpenMenu}
                                startIcon={<i className="icon-plus" style={{ fontSize: '12px' }} />}
                                sx={{
                                    borderRadius: '12px',
                                    textTransform: 'none',
                                    fontWeight: 700,
                                    bgcolor: '#10b981',
                                    px: 4,
                                    py: 1.2,
                                    boxShadow: '0 4px 14px rgba(16, 185, 129, 0.3)',
                                    '&:hover': {
                                        bgcolor: '#059669',
                                        transform: 'translateY(-1px)',
                                    }
                                }}
                            >
                                Add a Meal
                            </Button>
                        </Box>
                    )
                }
            </div>

            {/* --- FILL MEALS DIALOG --- */}
            <Dialog open={fillMealsModalOpen} onClose={() => setFillMealsModalOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Fill Missing Meals</DialogTitle>
                <DialogContent>
                    <Typography variant="body2" sx={{ mb: 2 }}>
                        This will create placeholder meals (e.g., "Meal Out") for selected times during your trip.
                        Existing meals will not be changed.
                    </Typography>

                    <FormGroup>
                        {["Breakfast", "Brunch", "Lunch", "Snack", "Dinner", "Dessert"].map((meal) => (
                            <FormControlLabel
                                key={meal}
                                control={
                                    <Checkbox
                                        checked={selectedMeals.includes(meal.toLowerCase())}
                                        onChange={() => toggleSelectedMeal(meal.toLowerCase())}
                                    />
                                }
                                label={meal}
                            />
                        ))}
                    </FormGroup>

                    <FormControlLabel
                        control={
                            <Switch
                                checked={mealType === "meal-out"}
                                onChange={() => setMealType(prev => prev === "meal-out" ? "meal-in" : "meal-out")}
                            />
                        }
                        label={mealType === "meal-out" ? "Meal Out" : "Meal In"}
                        sx={{ mt: 2 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setFillMealsModalOpen(false)}>Cancel</Button>
                    <Button
                        variant="contained"
                        onClick={handleConfirmFillMeals}
                        disabled={selectedMeals.length === 0}
                    >
                        Fill Meals
                    </Button>
                </DialogActions>
            </Dialog>

            {/* --- CONFIRMATION DELETE DIALOG --- */}
            <Dialog
                open={isDeleteDialogOpen}
                onClose={closeDeleteDialog}
                maxWidth="sm"
                PaperProps={{ sx: { borderRadius: "20px" } }}
            >
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    {/* Warning Icon Header */}
                    <Box
                        sx={{
                            display: 'inline-flex',
                            bgcolor: 'rgb(250,227,225)',
                            p: 2,
                            borderRadius: '50%',
                            mb: 2,
                        }}
                    >
                        <i className="icon-warning" style={{ color: 'rgb(211, 47, 47)', fontSize: '40px' }} />
                    </Box>

                    {/* Title */}
                    <DialogTitle
                        id="delete-meal-modal-title"
                        variant="h4"
                        component="h2"
                        fontWeight="bold"
                        sx={{ color: 'text.primary', m: 0, p: 0 }}
                    >
                        A Moment of Caution
                    </DialogTitle>

                    {/* Body Text */}
                    <DialogContent sx={{ p: 0, '&:first-of-type': { pt: 0 } }}>
                        <Typography variant="body1" sx={{ mt: 2, color: 'text.secondary', lineHeight: 1.6 }}>
                            <Box component="span" sx={{ fontWeight: 'bold', color: 'error.dark' }}>Heads up!</Box> Deleting this meal will remove it
                            <Box component="span" sx={{ fontWeight: 'bold', color: 'error.dark' }}> for everyone in the event</Box>, and this action
                            <Box component="span" sx={{ fontWeight: 'bold', color: 'error.dark' }}> cannot be undone</Box>.
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary', lineHeight: 1.6 }}>
                            This may also impact any associated expense tracking, orders, or receipts.
                            If an attendee no longer wants to participate in this meal, they can simply remove
                            themselves from the meal's attendee list without having to delete it for everyone.
                        </Typography>
                        <Typography variant="body1" sx={{ mt: 3, fontWeight: 'bold', color: 'text.primary' }}>
                            Are you sure you want to delete the meal "{
                            (mealToDelete?.eat_in_details && String(mealToDelete.eat_in_details).trim() !== "")
                                ? mealToDelete.eat_in_details
                                : (mealToDelete?.location?.name || mealToDelete?.title || mealToDelete?.name || "this meal")
                        }"?
                        </Typography>
                    </DialogContent>

                    {/* Action Buttons */}
                    <DialogActions sx={{ p: 0, mt: 4, justifyContent: 'center' }}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center" width="100%">
                            <Button
                                onClick={closeDeleteDialog}
                                variant="contained"
                                sx={{
                                    color: 'text.primary',
                                    bgcolor: 'grey.300',
                                    '&:hover': {
                                        bgcolor: 'grey.400',
                                    },
                                    borderRadius: '10px',
                                    boxShadow: 3,
                                    flexGrow: 1,
                                }}
                            >
                                No, Keep It
                            </Button>
                            <Button
                                onClick={() => handleDeleteMeal(mealToDelete?.id)}
                                variant="contained"
                                sx={{
                                    bgcolor: 'error.dark',
                                    '&:hover': {
                                        bgcolor: 'error.main',
                                    },
                                    borderRadius: '10px',
                                    boxShadow: 3,
                                    flexGrow: 1,
                                }}
                            >
                                Yes, Delete Meal
                            </Button>
                        </Stack>
                    </DialogActions>
                </Box>
            </Dialog>

            <InfoMeals
                isOpen={isMealsInfoDialogOpen}
                onClose={() => setMealsInfoDialogOpen(false)}
            />
        </div>
    )
}

export default MealsList;